import { Box } from "@mui/material";

export default function InfoHeader({
    children,
    paddingY = 2.5
}: InfoHeaderProps) {
    return (
        <Box
            p={1.5}
            py={paddingY}
            width="100%"
            bgcolor="rgb(237, 247, 237)"
            borderRadius={2}
            display="flex"
            justifyContent="space-between"
            flexDirection={{ xs: "column", md: "row" }}
            alignItems="center"
        >
            {children}
        </Box>
    )
}

interface InfoHeaderProps {
    children: React.ReactNode,
    paddingY?: number
}